import React from 'react';
import { Location, Navigate, BrowserRouter, Route, Routes, useLocation, useParams } from 'react-router-dom';
import UserRedirect from './UserRedirect';
import EventRedirect from './EventRedirect';
import DownloadRedirect from './DownloadRedirect';


export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/user/:userCode' element={<UserRedirect/>}/>
                <Route path='/event/:eventCode' element={<EventRedirect/>}/>
                <Route path='/download' element={<DownloadRedirect/>}/>
            </Routes>
        </BrowserRouter>
    );
}